// extracted by mini-css-extract-plugin
export default {"overlay":"ArticleGenerator_overlay__7I4RZ","copy":"ArticleGenerator_copy__LiPhd"};